export function asArray(value) {
  if (Array.isArray(value)) return value;
  if (value == null) return [];
  if (typeof value.toArray === 'function') return value.toArray();
  return [];
}

export function filterArray(value, predicate) {
  return asArray(value).filter(predicate);
}

export function findArray(value, predicate) {
  return asArray(value).find(predicate);
}
